<script setup>
import { ref } from "vue";
//import Conf from '@/Components/MainGlobal.vue';
import SeoMeta from '@/Components/SeoMeta.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { defineComponent } from 'vue';
import { GoogleMap, Marker } from "vue3-google-map";
import helpers from '@/Common/helpers';
import '@splidejs/vue-splide/css';

import BaseIcon from "@/Components/BaseIcon.vue";
import {
    mdiMagnify,
    mdiChevronDown,
    mdiAccountOutline,
    mdiCartOutline,
    mdiHeartOutline,
    mdiMenu,
    mdiCloseThick,
    mdiHeadset,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiWhatsapp,
    mdiYoutube,
    mdiTruckFastOutline,
    mdiReload,
    mdiShieldLockOutline,
    mdiTrophyOutline,
    mdiArrowRight,
    mdiShoppingOutline,
    mdiStar,
    mdiArrowExpandAll,
    mdiRepeat,
    mdiChevronRight,
    mdiMinus,
    mdiPlus,
    mdiFlagVariant,
    mdiMoped,
    mdiPercent,
    mdiPhone,
    mdiEmail,
    mdiMapMarker,
    mdiHandshakeOutline,
    mdiAccountGroupOutline,
    mdiShieldStarOutline,
    mdiTruckDeliveryOutline,
    mdiEmailFast

} from "@mdi/js";

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String,
    contentWelcome: String,
    accessStudents: Boolean,
    accessParents: Boolean,
    object: Object,
    tallas: Array,
    categoryChild: Object,
    categoryParent: Object,
    //connstantes: Array

})



// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

const form = useForm({
    email: '',
    nombre: '',
    phone: '',
    comment: '',
    recibirinfo: false
});
const isModalActive = ref(false);

const stocklabel = ref(false)

const companyInfo = ref(null)
companyInfo.value = [
    { 'id': '500', 'info': 'Empresa Peruana con más de 10 años... Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium unde aut itaque accusamus dolores rerum, quas in quos nostrum incidunt vero assumenda id fugit veritatis?', 'mision': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas unde soluta voluptates ex quo dolore, tempore odio impedit accusantium explicabo minus error, exercitationem porro nesciunt, similique quibusdam iure nihil iste.', 'imagen_mision': '/img/empresa/informacion/02.jpg', 'vision': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas unde soluta voluptates ex quo dolore, tempore odio impedit accusantium explicabo minus error, exercitationem porro nesciunt, similique quibusdam iure nihil iste.', 'imagen_vision': '/img/empresa/informacion/02.jpg' }
]

// Información de Slide, limite x 4

const slidePrincipal = ref(null)
slidePrincipal.value = [
    { 'id': '01', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-1.png' },
    { 'id': '02', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-2.png' },
    { 'id': '03', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-3.png' },
]

//produtos nuevos ORDER BY created_at LIMIT 8
const productosNuevos = ref(null)
productosNuevos.value = [
    { 'id': '28', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/01.jpg' },
    { 'id': '27', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 0, 'rating': 1, 'stock': '0', 'ruta_imagen': '/img/productos/02.jpg' },
    { 'id': '26', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 0, 'stock': '2', 'ruta_imagen': '/img/productos/03.jpg' },
    { 'id': '25', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/04.jpg' },
    { 'id': '24', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '1', 'ruta_imagen': '/img/productos/05.jpg' },
    { 'id': '23', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/06.jpg' },
    { 'id': '22', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/07.jpg' },
    { 'id': '21', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/08.jpg' }
]

const productosDestacados = ref(null)
productosDestacados.value = [
    { 'id': '31', 'label': 'Monitor Curvo Samsung 49″ WQLED LS49A950', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/20.jpg' },
    { 'id': '32', 'label': 'Tablet Samsung Galaxy Tab S7 Fe 64gb', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/21.jpg' },
    { 'id': '33', 'label': 'Asus ROG Strix RX5700 XT O8G 8GB', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/22.jpg' },
    { 'id': '34', 'label': 'Impresora HP LaserJet 107W', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/23.jpg' },
    { 'id': '35', 'label': 'Impresora Multifuncional Epson EcoTank L3110', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/24.jpg' },
    { 'id': '36', 'label': 'Mochila Lenovo Thinkpad Professional G2', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/25.jpg' }
]

const marcas = ref(null)
marcas.value = [
    { 'id': '101', 'ruta_imagen': '/img/marcas/01.png' },
    { 'id': '102', 'ruta_imagen': '/img/marcas/02.png' },
    { 'id': '103', 'ruta_imagen': '/img/marcas/03.png' },
    { 'id': '104', 'ruta_imagen': '/img/marcas/04.png' },
    { 'id': '105', 'ruta_imagen': '/img/marcas/05.png' },
    { 'id': '106', 'ruta_imagen': '/img/marcas/06.png' },
    { 'id': '107', 'ruta_imagen': '/img/marcas/07.png' },
    { 'id': '108', 'ruta_imagen': '/img/marcas/08.png' },
    { 'id': '109', 'ruta_imagen': '/img/marcas/09.png' },
    { 'id': '110', 'ruta_imagen': '/img/marcas/10.png' },
    { 'id': '111', 'ruta_imagen': '/img/marcas/11.png' },
    { 'id': '112', 'ruta_imagen': '/img/marcas/12.png' }
]


// Google maps
const YOUR_GOOGLE_MAPS_API_KEY = ref('AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg')
const center = ref({ lat: -11.992628, lng: -77.071254 })
const locations = ref([
    { lat: -11.992628, lng: -77.071254 }
])

// Formatos de fecha y tiempo
const formatDate = (datesource) => {
    //var now = new Date().toLocaleDateString()
    if (datesource) {
        var date = new Date(datesource + 'T00:00:00')// <-- Con let no funcionaba <-- Agregar la hora para que no reste un día por la zona horaria del navegador
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
        return result
    }

}

//console.log(props.object)
const formatDateTime = (datetime) => {
    if (datetime) {
        var date = new Date(datetime)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
        return result
    }

}

</script>

<!-- <script>

import { GoogleMap, Marker } from "vue3-google-map";

const YOUR_GOOGLE_MAPS_API_KEY = "AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg";

export default {
  name: "App",
  components: { GoogleMap, Marker },
  data() {
    const center = { lat: 40.689247, lng: -111.044502 };
    return { center, YOUR_GOOGLE_MAPS_API_KEY };
  },
};

</script> -->






<!-- <script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';


export default defineComponent({
    name: 'ThumbnailsExample',

    components: {
        Splide,
        SplideSlide,
    },

    setup() {
        
        const slides = generateSlides();


        onMounted(() => {
            const thumbsSplide = thumbs.value?.splide;

            if (thumbsSplide) {
                main.value?.sync(thumbsSplide);
            }
        });

        return {
            slides,
            main,
            thumbs,
            mainOptions,
            thumbsOptions,
        }
    },
});

</script> -->



<template>
    <SeoMeta />
    <!-- Head con categorías -->

    <head>
        <title>Términos y Condiciones - {{ (confGlobal.value.COMPANY_NAME_SHORT ? confGlobal.value.COMPANY_NAME_SHORT : 'Ecommerce') }}</title>
    </head>
    <BreezeGuestLayout :categoryChild="categoryChild" :categoryParent="categoryParent">


        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->

        <section>
            <div class="w-full h-[250px ] relative">
                <div aria-hidden="true" class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 inset-0 absolute bg-[url('/img/empresa/otros/compra_con_confianza.jpg')] bg-no-repeat bg-center bg-cover">
                </div>
                <div class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 absolute inset-0 bg-black bg-opacity-50">
                </div>
                <div class="mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-20">
                    <div class="relative flex flex-col lg:flex-row lg:justify-between items-center">
                        <div>
                            <h1 class="text-2xl lg:text-3xl text-white">Compra con Confianza</h1>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-white font-semibold">Inicio</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->

        <!-- START INFO EMPRESA -->
        <!-- START INFO EMPRESA -->
        <!-- START INFO EMPRESA -->

        <section>
            <div class="mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20" v-if="object">
                <div class="flex flex-row justify-center">
                    <div class="lg:basis-3/4">
                        <div class="mb-10">
                            <h1 class="text-2xl lg:text-3xl font-bold mb-4">Términos y Condiciones</h1>
                        </div>
                        <div class="mb-4">
                            <p class="text-sm text-gray-900 font-bold">Actualizado el {{ formatDateTime(object.updated_at) }}</p>
                        </div>
                        <div class="mb-4" v-html="object.value">
                        </div>

                        <hr class="my-6">
                        <div class="flex flex-col lg:flex-row lg:items-center justify-center lg:space-x-4 ">
                            <p class="text-base font-semibold text-gray-800 mb-4 lg:mb-0">Si cuenta con consultas al respecto...</p>
                            <Link :href="route('eco-contactinfo')" class="btn btn-color btn-ico">
                                <BaseIcon :path="mdiEmailFast" :size="20" class="mr-2" /> Contactanos
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

        </section>
        <!-- END INFO EMPRESA -->
        <!-- END INFO EMPRESA -->
        <!-- END INFO EMPRESA -->




        <!-- <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div class="grid grid-cols-2">
                <div class="col-span-1">
                    <Splide id="main-carousel" :options="{
                        type: 'fade',
                        rewind: true,
                        pagination: false,
                        arrows: false,
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>

                    <Splide :options="{
                        fixedWidth: 100,
                        fixedHeight: 60,
                        gap: 10,
                        rewind: true,
                        pagination: false,
                        cover: true,
                        focus: 'center',
                        breakpoints: {
                            600: {
                                fixedWidth: 60,
                                fixedHeight: 44,
                            },
                        },
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/04.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/05.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>
                </div>
            </div>

        </div> -->


    </BreezeGuestLayout>
</template>

<style scoped>
.splide__slide img {

    object-fit: cover;
}
</style>
